/**
 * @file   src\components\Introduction\PendingSendIntroductionList.js
 * @brief  This file is responsible for the user send pending introductions list.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import IntroductionData from "./IntroductionData";
import IntroStatusLine from "@/components/IntroStatusLine";

const PendingSendIntroductionList = (props) => {
  const {
    list,
    count,
    updateIntroPageOnScroll,
    CancelIntroduction,
    acceptedCount,
  } = props;

  const scrollRef = useRef(null);

  // To handle the page scroll for pagination
  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      const section = "pending";
      updateIntroPageOnScroll(section);
    }
  };

  return (
    <>
      {count > 0 ? (
        <div className="intro-list-sec">
          <div className="title-sec">
            <h5>
              Pending <span>({count})</span>
            </h5>
          </div>
          <div
            className="property-block-scroll"
            onScroll={handleScroll}
            ref={scrollRef}
          >
            {list.map((intro) => {
              const introId = _.get(intro, "IntroductionId", "");
              return (
                <div className="property-block" key={introId}>
                  <div
                    className="property-info property-info-hoverstyling"
                    onClick={() => {
                      props.ViewWantAd(introId);
                    }}
                  >
                    <IntroductionData introList={intro} />
                    <IntroStatusLine status={props.statusById?.[introId]} />
                  </div>
                  <div className="property-action flex-shrink-0">
                    <Button
                      variant="light"
                      className="btn-cancel"
                      onClick={() => {
                        CancelIntroduction(introId);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant=""
                      className="btn-tertiary"
                      onClick={() => {
                        props.ViewWantAd(introId);
                      }}
                    >
                      View Introduction
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        acceptedCount == 0 && <p>No Introductions.</p>
      )}
    </>
  );
};
export default PendingSendIntroductionList;
